import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SVGMatIconModule, TranslateDirective, TranslatePipe } from '@speedy/core';

@Component({
  standalone: true,
  selector: 'app-speedy-button',
  templateUrl: './speedy-button.component.html',
  styleUrls: ['./speedy-button.component.scss'],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    TranslateDirective,
    SVGMatIconModule,
    TranslatePipe,
  ],
})
export class SpeedyButtonComponent {
  /** Flag to set the text */
  @Input() text = '';

  /** Flag to set the icon before text */
  @Input() iconPrefix = '';

  /** Flag to set the icon after text */
  @Input() iconSuffix = '';

  /** Flag to set if the button in loading state */
  @Input() loading = false;

  /** Flag to set if the button in success state */
  @Input() loadingSuccess = false;

  /** Flag to set the mat-progress-spinner size */
  @Input() spinnerSize = 35;

  /** Flag to set the extra button classes */
  @Input() buttonClass = '';

  /** Flag to change button to type outline */
  @Input() outline = false;

  /** Flag to change button to disabled state */
  @Input() disabled = false;

  @Output() clicked = new EventEmitter();
}
